import React, { useState, useCallback } from "react";
import { Card } from "../layouts/Card";
import { ControlButtons } from "../charts/ControlButtons";
import { ChartContainer } from "../charts/ChartContainer";
import { StatBoxes, StatBox } from "../charts/StatBox";
import useFetch from "../../hooks/fetchData";

const StatBoxesCard = ({
  title,
  subtitle,
  footnote = null,
  endpoint,
  colspan = 1,
  width = null,
  height = 150,
  outline = false,
  className = "",
  chartProps = {},
  id = null,
  children = null,
}) => {
  const { data, loading, error, toggleDataFormat, isPercentage } = useFetch(
    endpoint,
    true
  );
  const [showControls, setShowControls] = useState(false);

  const handleMouseEnter = useCallback(() => setShowControls(true), []);
  const handleMouseLeave = useCallback(() => setShowControls(false), []);

  return (
    <Card
      title={title}
      subtitle={subtitle}
      footnote={footnote}
      colspan={colspan}
      outline={outline}
      className={className}
      id={id}
    >
      {children}
      <ChartContainer
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data={data}
        isPercentage={isPercentage}
        toggleDataFormat={toggleDataFormat}
      >
        {showControls && (
          <ControlButtons
            data={data}
            isPercentage={isPercentage}
            toggleDataFormat={toggleDataFormat}
          />
        )}
        <StatBoxes
          loading={loading}
          chartData={data}
          isPercentage={isPercentage}
          width={width}
          height={height}
          labelFontSize={".75rem"}
          valueFontSize={"2.5rem"}
          {...chartProps}
        />
      </ChartContainer>
    </Card>
  );
};

const getPercentileColor = (percentile) => {
  if (percentile >= 70) return "#22c55e"; // green-500
  if (percentile <= 30) return "#ef4444"; // red-500
  return "#64748b"; // slate-500
};

const StatBoxesDataCard = ({
  title,
  subtitle,
  footnote = null,
  data,
  colspan = 1,
  width = null,
  height = 150,
  outline = false,
  className = "",
  id = null,
  children = null,
  showPercentileBar = false,
}) => {
  if (!data || (Array.isArray(data) && data.length === 0)) return null;
  return (
    <Card
      title={title}
      subtitle={subtitle}
      footnote={footnote}
      colspan={colspan}
      outline={outline}
      className={className}
      id={id}
    >
      {children}
      <div className="flex flex-wrap gap-4 py-4">
        {data.map((stat, idx) => {
          return (
            <div
              key={stat.label}
              style={{ minWidth: 180, flex: "1 0 180px", maxWidth: 220 }}
            >
              <StatBox
                label={stat.label}
                value={stat.value}
                labelFontSize={".75rem"}
                valueFontSize={"2.5rem"}
                height={120}
                width={200}
                percentile={stat.percentile}
                showPercentileBar={showPercentileBar}
              />
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export { StatBoxesCard, StatBoxesDataCard };
